export enum GAEvents {
  instock = 'instock',
  bookingCar = 'booking-car',
}

export type GATrackingEventDetail = {
  gaEvent: GAEvents;
  data?: Record<string, any>;
};

export type TCarStatus = 'active' | 'sold' | 'transit' | 'distributed';
export type TCarGroup = 'new' | 'used';
